<template>
  <section>
    <v-progress-linear
      class="mt-n3"
      absolute
      indeterminate
      color="primary"
      v-if="loading || isGetSubscriptionPending"
    ></v-progress-linear>
    <Confirm
      :confirm.sync="confirmCancel"
      :callback="cancelSubscription"
      width="400"
      message="If you cancel your subscription your bot will be disabled, continue?"
    ></Confirm>
    <Confirm
      :confirm.sync="confirmSuspend"
      :callback="suspendSubscription"
      width="400"
      message="If you suspend your subscription your bot will be disabled (but you can reactivate your subscription at any time), continue?"
    ></Confirm>
    <!--<v-tabs v-model="tab" background-color="transparent" color="accent" grow>
      <v-tab>Subscription</v-tab>
      <v-tab>Add-On Features</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
    <v-tab-item>-->
    <v-alert
      border="left"
      outlined
      type="error"
      elevation="2"
      class="mt-4"
      v-if="error"
    >{{error.message}}</v-alert>

    <v-alert
      border="left"
      color="primary"
      type="info"
      class="mt-4"
      dense
      text
      colored-border
      v-if="mustApprove"
    >
      <v-row align="center">
        <v-col class="grow">Please approve this revision with Paypal.</v-col>
        <v-col class="shrink">
          <v-btn color="primary" :href="subscription.revise_approval_link" target="_blank">
            <v-icon>mdi-check</v-icon>Approve
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-row class="mb-4" justify="center" v-if="isCustomSubscription">
      <v-col cols="12">
        <v-list>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-h4 font-weight-light">{{paypalSubscription.name}}</v-list-item-title>
              <v-list-item-subtitle class="subtitle-1">{{paypalSubscription.description}}.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="!isCustomSubscription">
      <v-col cols="12" v-if="paypalRevisedPlan">
        <v-card class="mx-auto" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">REVISED SUBSCRIPTION PLAN</div>
              <v-list-item-title class="text-h4 mb-1">{{paypalRevisedPlan.name}}</v-list-item-title>
              <v-list-item-subtitle>{{paypalRevisedPlan.description}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item two-line>
                  <v-list-item-icon>
                    <v-icon x-large color="primary">mdi-currency-usd</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="headline font-weight-medium"
                    >{{paypalRevisedPlanPrice && paypalRevisedPlanPrice.pricing_scheme ? paypalRevisedPlanPrice.pricing_scheme.fixed_price.value : '' | currency}} / m</v-list-item-title>
                    <v-list-item-subtitle
                      class="subtitle-1"
                    >{{paypalRevisedPlanPrice && paypalRevisedPlanPrice.pricing_scheme ? paypalRevisedPlanPrice.pricing_scheme.fixed_price.currency_code : ''}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              color="primary"
              @click="reviseSubscription()"
              v-if="needsRevision && subscription.revise_type === 'upgrade'"
            >
              <v-icon left>mdi-cart-arrow-up</v-icon>Upgrade
            </v-btn>
            <v-btn
              outlined
              color="primary"
              @click="reviseSubscription()"
              v-if="needsRevision && subscription.revise_type === 'downgrade'"
            >
              <v-icon left>mdi-cart-arrow-down</v-icon>Downgrade
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" v-if="paypalPlanPrice">
        <v-card class="mx-auto" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">CURRENT SUBSCRIPTION PLAN</div>
              <v-list-item-title class="text-h4 mb-1">{{paypalPlan.name}}</v-list-item-title>
              <v-list-item-subtitle>{{paypalPlan.description}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item two-line>
                  <v-list-item-icon>
                    <v-icon x-large color="primary">mdi-currency-usd</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      v-if="subscription.free"
                      class="headline font-weight-medium">Free</v-list-item-title>
                    <v-list-item-title
                      v-if="!subscription.free"
                      class="headline font-weight-medium"
                    >{{paypalPlanPrice && paypalPlanPrice.pricing_scheme ? paypalPlanPrice.pricing_scheme.fixed_price.value : '' | currency}} / m</v-list-item-title>
                    <v-list-item-subtitle
                      class="subtitle-1"
                    >{{paypalPlanPrice && paypalPlanPrice.pricing_scheme ? paypalPlanPrice.pricing_scheme.fixed_price.currency_code : ''}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line v-if="botConfigured">
                  <v-list-item-icon>
                    <v-icon large color="primary">mdi-telegram</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="headline font-weight-light">{{botCount}}</v-list-item-title>
                    <v-list-item-subtitle class="subtitle-1">{{botCount === 1 ? 'Bot':'Bots'}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line v-if="botConfigured">
                  <v-list-item-icon>
                    <v-icon large color="primary">mdi-account-group</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="headline font-weight-light">{{totalMembers()}}</v-list-item-title>
                    <v-list-item-subtitle class="subtitle-1">Total members</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6" v-if="!subscription.free">
                <v-list class="text-right" v-if="hasPaypalSubscription">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title
                        class="headline font-weight-light"
                      >{{paypalSubscription.status | title_case}}</v-list-item-title>
                      <v-list-item-subtitle class="subtitle-1">Subscription status</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon
                        large
                        :color="paypalSubscription.status === 'ACTIVE' ? 'success': (paypalSubscription.status === 'SUSPENDED' ? 'warning' : 'error')"
                      >{{paypalSubscription.status === 'CANCELLED' ? 'mdi-cancel' : 'mdi-check'}}</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item two-line v-if="paypalSubscription.status !== 'ACTIVE'">
                    <v-list-item-content>
                      <v-list-item-title
                        class="headline font-weight-light"
                      >{{subscription.suspend_date || subscription.cancel_date | date_only}}</v-list-item-title>
                      <v-list-item-subtitle class="subtitle-1">Deactivation date</v-list-item-subtitle>
                      <p class="grey--text">Date on which your bot/s will be deactivated (at the end of your current billing cycle).</p>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon
                        large
                        color="error"
                      >mdi-cloud-off-outline</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item
                    two-line
                    v-if="paypalSubscriptionBilling.next_billing_time && (!paypalSubscriptionTrial || (paypalSubscriptionTrial && paypalSubscriptionTrial.cycles_completed === 1))"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        class="headline font-weight-light"
                      >{{paypalSubscriptionBilling.next_billing_time | date_only}}</v-list-item-title>
                      <v-list-item-subtitle class="subtitle-1">Next billing date</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon large>mdi-update</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list>
                <div v-if="!hasPaypalSubscription && paypalPlan">
                  <div class="text-right">
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon large color="primary">mdi-exclamation</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <p
                          class="text-h6 font-weight-light"
                        >To use GroupBot you'll need to first subscribe.</p>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                  <div class="text-left">
                    <p
                      class="body-1"
                      v-if="subscription && subscription.includes_trial"
                    >You will not be charged for the first 14 days and can cancel your subscription at any time.</p>
                    <p
                      class="caption"
                      v-if="subscription && !subscription.includes_trial"
                    >You do not qualify for a free trial and will be charged immediately.</p>
                  </div>
                  <v-progress-circular
                    class="align-self-center ma-4"
                    indeterminate
                    color="accent"
                    v-if="!paypalButtonsRendered"
                  ></v-progress-circular>
                  <div id="paypal-button-container"></div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-4"
              outlined
              color="success"
              @click="reActivateSubscription()"
              v-if="paypalSubscription && paypalSubscription.status === 'SUSPENDED'"
            >
              <v-icon left>mdi-power</v-icon>Re-activate
            </v-btn>
            <v-btn
              class="mr-4"
              outlined
              color="warning"
              @click="confirmSuspend = true"
              v-if="paypalSubscription && paypalSubscription.status === 'ACTIVE'"
            >
              <v-icon left>mdi-pause-circle-outline</v-icon>Suspend
            </v-btn>
            <v-btn
              outlined
              color="red"
              @click="confirmCancel = true"
              v-if="paypalSubscription && (paypalSubscription.status === 'ACTIVE' || paypalSubscription.status === 'SUSPENDED')"
            >
              <v-icon left>mdi-cancel</v-icon>Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <!--
          <v-col cols="12" md="6" v-if="paypalPlanPrice">
            <v-list>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h4 font-weight-light">{{paypalPlan.name}}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-1">{{paypalPlan.description}}.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-icon>
                  <v-icon x-large color="primary">mdi-currency-usd</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-h4 font-weight-medium"
                  >{{paypalPlanPrice && paypalPlanPrice.pricing_scheme ? paypalPlanPrice.pricing_scheme.fixed_price.value : '' | currency}} / m</v-list-item-title>
                  <v-list-item-subtitle
                    class="subtitle-1"
                  >{{paypalPlanPrice && paypalPlanPrice.pricing_scheme ? paypalPlanPrice.pricing_scheme.fixed_price.currency_code : ''}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line v-if="botConfigured">
                <v-list-item-icon>
                  <v-icon large color="primary">mdi-account-group</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-h4 font-weight-light">{{totalMembers()}}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-1">Total group members</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="12" md="6" v-if="paypalRevisedPlan">
            <v-list>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h4 font-weight-light">{{paypalRevisedPlan.name}}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-1">{{paypalRevisedPlan.description}}.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col
            class="d-flex flex-column align-end justify-center"
            cols="12"
            md="6"
            v-if="!hasPaypalSubscription && paypalPlan"
          >
            <div class="text-right">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon large color="primary">mdi-exclamation</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <p
                    class="text-h6 font-weight-light"
                  >To use GroupBot you'll need to first subscribe.</p>
                </v-list-item-content>
              </v-list-item>
            </div>
            <div class="text-left">
              <p
                class="body-1"
              >You will not be charged for the first 14 days and can cancel your subscription at any time.</p>
            </div>
            <v-progress-circular
              class="align-self-center ma-4"
              indeterminate
              color="accent"
              v-if="!paypalButtonsRendered"
            ></v-progress-circular>
            <div id="paypal-button-container"></div>
          </v-col>
          <v-col class="d-flex flex-column align-end" cols="12" md="6" v-if="hasPaypalSubscription">
            <v-list class="text-right">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-h4 font-weight-light"
                  >{{paypalSubscription.status | title_case}}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-1">Subscription status</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon
                    large
                    :color="paypalSubscription.status === 'ACTIVE' ? 'success': (paypalSubscription.status === 'SUSPENDED' ? 'warning' : 'danger')"
                  >mdi-check</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item
                two-line
                v-if="paypalSubscriptionBilling.next_billing_time && (!paypalSubscriptionTrial || (paypalSubscriptionTrial && paypalSubscriptionTrial.cycles_completed === 1))"
              >
                <v-list-item-content>
                  <v-list-item-title
                    class="text-h5 font-weight-light"
                  >{{paypalSubscriptionBilling.next_billing_time | date_only}}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-1">Next billing date</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon large>mdi-update</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
            

            <div class="mt-auto mb-4 align-self-end">
              <v-btn
                outlined
                color="primary"
                @click="reviseSubscription()"
                v-if="needsRevision && subscription.revise_type === 'upgrade'"
              >
                <v-icon left>mdi-cart-arrow-up</v-icon>Upgrade
              </v-btn>
              <v-btn
                outlined
                color="primary"
                @click="reviseSubscription()"
                v-if="needsRevision && subscription.revise_type === 'downgrade'"
              >
                <v-icon left>mdi-cart-arrow-down</v-icon>Downgrade
              </v-btn>
            </div>
            <div class="mt-auto mb-4 align-self-end">
              <v-btn
                class="mr-4"
                outlined
                color="success"
                @click="reActivateSubscription()"
                v-if="paypalSubscription.status === 'SUSPENDED'"
              >
                <v-icon left>mdi-power</v-icon>Re-activate
              </v-btn>
              <v-btn
                class="mr-4"
                outlined
                color="warning"
                @click="confirmSuspend = true"
                v-if="paypalSubscription.status === 'ACTIVE'"
              >
                <v-icon left>mdi-pause-circle-outline</v-icon>Suspend
              </v-btn>
              <v-btn
                outlined
                color="red"
                @click="confirmCancel = true"
                v-if="paypalSubscription.status === 'ACTIVE' || paypalSubscription.status === 'SUSPENDED'"
              >
                <v-icon left>mdi-cancel</v-icon>Cancel
              </v-btn>
            </div>
      </v-col>-->
    </v-row>
    <!--</v-tab-item>
      <v-tab-item>
        <Features></Features>
      </v-tab-item>
    </v-tabs-items>-->
  </section>
</template>

<script>
//import moment from "moment";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { makeFindMixin, makeGetMixin } from "feathers-vuex";
//import Features from "@/components/config/subscription/Features";
import Confirm from "@/components/widget/Confirm";
//const { Subscription } = models.api;

export default {
  data: () => ({
    tab: null,
    error: null,
    loading: false,
    paypalLoaded: false,
    paypalButtonsRendered: false,
    confirmCancel: false,
    confirmSuspend: false,
    paypalClientId: process.env.VUE_APP_PAYPAL_CLIENT_ID,
  }),
  mixins: [
    makeFindMixin({ service: "groups", queryWhen: "botConfigured" }),
    makeGetMixin({ service: "subscription", id: "subscriptionID" }),
  ],
  created() {},
  mounted() {
    let paypalScript = document.createElement("script");
    paypalScript.setAttribute(
      "src",
      `https://www.paypal.com/sdk/js?client-id=${this.paypalClientId}&vault=true`
    );
    paypalScript.setAttribute("data-sdk-integration-source", "button-factory");
    document.head.appendChild(paypalScript);
    paypalScript.addEventListener("load", this.paypalScriptLoaded);
  },
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    botConfigured() {
      return !!(
        this.user &&
        this.user.account &&
        this.user.account.bots &&
        this.user.account.bots.length
      );
    },
    botCount() {
      return (
        this.user &&
        this.user.account &&
        this.user.account.bots &&
        this.user.account.bots.length
      );
    },
    subscriptionID() {
      return (
        this.user &&
        this.user.account &&
        this.user.account.subscription &&
        this.user.account.subscription.id
      );
    },
    paypalPlan() {
      return this.subscription && this.subscription.paypal_plan;
    },
    paypalRevisedPlan() {
      return this.subscription && this.subscription.revised_plan;
    },
    paypalSubscription() {
      return this.subscription && this.subscription.paypal_subscription;
    },
    isCustomSubscription() {
      return (
        this.subscription &&
        this.subscription.paypal_subscription &&
        this.subscription.paypal_subscription.id &&
        this.subscription.paypal_subscription.id === "custom"
      );
    },
    hasPaypalSubscription() {
      return !!(
        this.subscription &&
        this.subscription.paypal_subscription &&
        this.subscription.paypal_subscription.id &&
        this.subscription.paypal_subscription.id !== "custom"
      );
    },
    paypalPlanPrice() {
      return (
        this.subscription &&
        this.subscription.paypal_plan &&
        this.subscription.paypal_plan.billing_cycles &&
        this.subscription.paypal_plan.billing_cycles.find(
          (cycle) => cycle.tenure_type === "REGULAR"
        )
      );
    },
    paypalRevisedPlanPrice() {
      return (
        this.subscription &&
        this.subscription.revised_plan &&
        this.subscription.revised_plan.billing_cycles &&
        this.subscription.revised_plan.billing_cycles.find(
          (cycle) => cycle.tenure_type === "REGULAR"
        )
      );
    },
    paypalSubscriptionBilling() {
      return (
        (this.paypalSubscription && this.paypalSubscription.billing_info) || {}
      );
    },
    paypalSubscriptionTrial() {
      return (
        this.paypalSubscriptionBilling &&
        this.paypalSubscriptionBilling.cycle_executions &&
        this.paypalSubscriptionBilling.cycle_executions.find(
          (cycle) => cycle.tenure_type === "TRIAL"
        )
      );
    },
    needsRevision() {
      return this.subscription && this.subscription.needs_revision;
    },
    mustApprove() {
      return (
        this.subscription &&
        this.subscription.revise_approval_link &&
        this.subscription.needs_revision
      );
    },
    groupsParams() {
      return {
        query: {
          $select: ["id", "title", "member_count"],
        },
      };
    },
  },
  methods: {
    ...mapActions("users", { getUser: "get" }),
    ...mapActions("app", ["showMessage"]),
    async saveSubscription(reload, params = {}) {
      this.loading = true;
      try {
        await this.subscription.save(params);
        if (reload) {
          await this.getSubscription();
          //await this.getUser(this.user.id);
        }
        this.loading = false;
      } catch (error) {
        this.error = error;
        this.loading = false;
      }
    },
    async suspendSubscription() {
      await this.saveSubscription(true, {
        query: {
          action: "suspend",
          reason: "User initiated suspension",
        },
      });
    },
    async cancelSubscription() {
      await this.saveSubscription(true, {
        query: {
          action: "cancel",
          reason: "User initiated cancellation",
        },
      });
    },
    async reActivateSubscription() {
      await this.saveSubscription(true, {
        query: {
          action: "activate",
          reason: "User initiated re-activation",
        },
      });
    },
    async reviseSubscription() {
      await this.saveSubscription(true, {
        query: {
          action: "revise",
          reason: "User initiated plan revision",
        },
      });
    },
    paypalScriptLoaded() {
      this.paypalLoaded = true;
    },
    renderPaypalButtons() {
      if (
        !this.paypalLoaded ||
        this.hasPaypalSubscription ||
        !this.subscription ||
        this.subscription.free
      )
        return;

      window.paypal
        .Buttons({
          style: {
            shape: "rect",
            color: this.$vuetify.theme.dark ? "black" : "white",
            layout: "vertical",
            label: "subscribe",
          },
          createSubscription: (data, actions) => {
            return actions.subscription.create({
              plan_id: this.paypalPlan.id,
            });
          },
          onApprove: async (data) => {
            this.subscription.paypal_subscription = data;
            await this.saveSubscription(true);
          } /*,
          onCancel: function (data) {
            // Show a cancel page, or return to cart
            console.log("onCancel", data);
          },
          onError: function (err) {
            // Show an error page here, when an error occurs
            console.log("onError", err);
          },*/,
        })
        .render("#paypal-button-container");

      this.paypalButtonsRendered = true;
    },
    totalMembers() {
      let total = 0;
      let bots = this.user.account && this.user.account.bots;

      if (!bots || !bots.length) return total;

      bots.forEach((bot) => {
        total += bot.member_count;
      });
      return total;
    },
  },
  watch: {
    paypalPlan(plan) {
      if (plan && plan.id && !this.paypalButtonsRendered) {
        Vue.nextTick(() => {
          this.renderPaypalButtons();
        });
      }
    },
  },
  components: {
    Confirm,
    //Features,
  },
  props: {},
};
</script>

<style lang="scss" scoped>
#paypal-button-container {
  width: 100%;
}
</style>